import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch, Filter_Update_Request } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, ComplainSearch_GroupBy, JobSearch_Compact_Mode } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, ListResponse } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { TopFilterStatModel, SearchTextResult } from '../../Models/CommonModels';
import * as alasql from 'alasql';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../Services/UserService';
import { JobSearchResult_Compact } from '../JobSearchResult_Compact/JobSearchResult_Compact';

@Component({
    selector: 'JobConsole_Compact',
    templateUrl: './JobConsole_Compact.html'
})

export class JobConsole_Compact extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('jobSearchResult') jobSearchResult: JobSearchResult_Compact;

    RequestModel: ComplainSearch;
    Model: ListResponse;
    _LocationId: number;
    DateFormat: string;
    cDate: Date = new Date();
    PropStatModel: Array<TopFilterStatModel> = [];
    isLoading: Boolean = false;
    SelectedProperties: Array<number> = [];
    @Input() Mode: JobSearch_Compact_Mode = JobSearch_Compact_Mode.Location;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService, public userService: UserService) {
        super(translate, toastr, route, router, masterService);

        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.InitRequestModel();

        this.PopulateTopFilters();
    }

    ngOnDestroy(): void {
        //window.clearInterval(this.Timer);
    }


    ngOnInit(): void {
        
    }

    InitRequestModel(): void {
        this.RequestModel = new ComplainSearch();
        this.RequestModel.SetDefaults();
    }

    PopulateTopFilters(): void {
        this.PropStatModel.push({
            Id: null,
            IconClass: 'fa fa-bars',
            Label: 'SHORT_NAME.SHORT_NAME_ALL',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: 'OPN',
            IconClass: 'fa fa-unlock-alt',
            Label: 'SHORT_NAME.SHORT_NAME_OPN',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: 'USN',
            IconClass: 'fa fa-minus-square',
            Label: 'SHORT_NAME.SHORT_NAME_UNS',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: 'PRK',
            IconClass: 'fa fa-hourglass-start',
            Label: 'SHORT_NAME.SHORT_NAME_PRK',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: 'SNL',
            IconClass: 'fa fa-user-times',
            Label: 'SHORT_NAME.SHORT_NAME_SNL',
            Value: 0
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: 'CLS',
            IconClass: 'fa fa-lock',
            Label: 'SHORT_NAME.SHORT_NAME_CLS',
            Value: 0
        } as TopFilterStatModel);
    }

    FindStatus(Status: string): TopFilterStatModel {
        return this.PropStatModel.find(value => {
            return value.Id == Status;
        });
    }

    Transform_TopFilter(lst: any): void {
        let totalCount = 0;

        if (lst == null) {
            //console.info("A = " + this.PropStatModel.length);
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];
                row.Value = 0;

                if (row != null && row.Id != null) {
                    totalCount = totalCount + row.Value;
                }
            }
        }
        else {
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    let count = alasql("Select SUM([Count]) as cnt from ? where StatusCode = ?", [lst, row.Id]);

                    row.Value = count[0].cnt;
                    totalCount = totalCount + row.Value;
                }
            }
        }            
        this.FindStatus(null).Value = totalCount;
    }

    SetTopStatusData(): void {
        this.isLoading = true;
        this.complainService.Complain_StatusCounts(this.RequestModel).then(data => {
            this.isLoading = false;
            this.Transform_TopFilter(data)
        });
    }

    onTopFilter(StatusCode: string): void {
        this.RequestModel.StatusCode = StatusCode;
        this.jobSearchResult.Show();
        //this.SetTopStatusData();
    }

    RefreshData(): void {
        this.SetTopStatusData();
    }

    Open(req: ComplainSearch): void {
        this.Transform_TopFilter(null);

        if (req == null || req.Properties == null || req.Properties.length == 0) {
            this.RequestModel = null;
            this.Model = null;
            this.jobSearchResult.RequestModel = null;
            this.jobSearchResult.Show();
            
            return;
        }
        
        this.RequestModel = _.cloneDeep(req);
        this.RequestModel.StatusCode = CallStatuses.Open;
        this.RefreshData();
        this.jobSearchResult.RequestModel = this.RequestModel;
        this.jobSearchResult.Show();
    }
}
